module.exports = __webpack_public_path__ + "img/inspiration.384cdd8e.png";